import svg from '../../assets/svg/noData.svg';
import '../../styles/generic/noData.scss';
import MainSquareButton from '../buttons/MainSquareButton';

interface Props {
  title: string;
  subTitle?: string;
  buttonTitle?: string;
  buttonAction?: () => void;
}

const NoData = ({ title, subTitle, buttonTitle, buttonAction }: Props) => {
  return (
    <div className='noData'>
      <img src={svg} alt='noData' />
      <h1 className='noData--title'>{title}</h1>
      <p className='noData--subtitle'>{subTitle}</p>
      {buttonTitle && buttonAction && (
        <MainSquareButton
          onClick={() => {
            buttonAction && buttonAction();
          }}
          type={'button'}
          value={buttonTitle}
          normal={true}
          buttonType='white'
        />
      )}
    </div>
  );
};

export default NoData;
